import { CarouselController } from "../carousel_controller"
import styles from "components/attachments/image_carousel_component.module.scss.json"

export default class extends CarouselController {}
